module.exports = __webpack_public_path__ + "static/media/blob-hero.d8cb505b.svg";